import LookerEmbedTab from 'components/LookerEmbedTab'
import React from 'react'

const DASHBOARD_PATH = 'dashboards/359'

const RedemptionRevenueTab: React.FC = () => (
  <LookerEmbedTab
    path={DASHBOARD_PATH}
    translationKey="thanx_campaigns.performance.redemptionRevenue"
  />
)

export default RedemptionRevenueTab
